"use client";
import { Navigation } from "swiper/modules";
import SectionWrapper from "@/commonComponents/section-wrapper";
import { Body1, H1 } from "@/styles/theme/components/typography.fontvariant";
import EnhancedSwiper from "@/commonComponents/enhanced-swiper";
import SwiperNavigationButton from "@/commonComponents/swiper-navigation-button";
import AwardCard, { AwardCardProps } from "@/commonComponents/cards/award-card";
import { staggerTextChildrenLowOpacity } from "@/commonComponents/animations";
import { AnimatedButtonProps } from "@cc/animated-button";

export interface BajajAwardsProps {
  title: string;
  description: string;
  LinkProps?: AnimatedButtonProps;
  awards: AwardCardProps[];
  navId?: string;
}

const BajajAwards = (props: BajajAwardsProps) => {
  const { title, description, LinkProps, awards, navId } = props;
  return (
    <SectionWrapper
      navId={navId || "awards"}
      SectionProps={{
        sx: {
          background: (theme) => theme.palette.gradient.darkToLight,
        },
        id: "awards",
      }}
      SectionHeaderProps={{
        title,
        description,
        TitleTypographyProps: {
          variant: "h3",
          fontSize: H1,
        },
        DescriptionTypographyProps: {
          fontSize: Body1,
          maxWidth: 867,
          variants: staggerTextChildrenLowOpacity(0.8),
          textAlign:'justify',
        },
        LinkProps: LinkProps
          ? {
              variant: "contained",
              ...LinkProps,
            }
          : undefined,
        mb: { xs: 6, md: 3 },
        isArrow: true,
      }}
    >
      <EnhancedSwiper
        slidesPerView={"auto"}
        SlideWrapperProps={{
          sx: {
            width: 310,
            mr: 3,
            alignSelf: "center",
          },
        }}
        sx={{
          pt: { xs: 6, md: 7 },
          overflow: { xs: "visible", xxl: "hidden" },
        }}
        SlideComponent={AwardCard}
        data={awards}
        navigation={{
          enabled: true,
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev",
        }}
        modules={[Navigation]}
        SlideComponentProps={(index) => ({
          initial: {
            opacity: 0,
            y: "100%",
          },
          whileInView: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.6,
              delay: index * 0.5,
            },
          },
          viewport: {
            once: true,
          },
        })}
        Slots={{
          ContainerEndChildren: (
            <SwiperNavigationButton
              display={{ xs: "flex", md: "none" }}
              mt={{ xs: 5, md: 6 }}
              alignSelf={"center"}
              PrevButtonProps={{
                className: "swiper-prev",
              }}
              NextButtonProps={{
                className: "swiper-next",
              }}
            />
          ),
        }}
      />
    </SectionWrapper>
  );
};

export default BajajAwards;
